/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdChatStatistics200,
  GetApiV1ClassroomdisciplineIdChatStatistics401,
  GetApiV1ClassroomdisciplineIdChatStatistics404,
  GetApiV1ClassroomdisciplineIdChatStatistics500,
  GetApiV1ClassroomdisciplineIdChatStatisticsPathParams,
  GetApiV1ClassroomdisciplineIdChatStatisticsQueryParams,
  GetApiV1ClassroomdisciplineIdChatStatisticsQueryResponse,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineIdChatStatistics.ts";
import { chatStatisticsViewModelSchema } from "../chatStatisticsViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdChatStatisticsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatisticsPathParams>;

export const getApiV1ClassroomdisciplineIdChatStatisticsQueryParamsSchema = z
  .object({
    classStudentId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatisticsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdChatStatistics200Schema = z.lazy(
  () => chatStatisticsViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatistics200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdChatStatistics401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatistics401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdChatStatistics404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatistics404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineIdChatStatistics500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatistics500>;

export const getApiV1ClassroomdisciplineIdChatStatisticsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdChatStatistics200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChatStatisticsQueryResponse>;
